import { render, staticRenderFns } from "./summary-material.vue?vue&type=template&id=77fb8016&scoped=true&"
import script from "./summary-material.vue?vue&type=script&lang=js&"
export * from "./summary-material.vue?vue&type=script&lang=js&"
import style0 from "./summary-material.vue?vue&type=style&index=0&id=77fb8016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb8016",
  null
  
)

export default component.exports